export const initNotificationPoints = (state) => {
  if (state && state.points) {
    const { points } = state;
    const confirmedPoints = points.filter((point) => point.isConfirmed);
    const confirmedPointType = (confirmedPoints.length === 1 && points.length === 2) ? confirmedPoints[0].type : false;
    const newPoints = points.map((point) => ({
      ...point,
      isEditing: false,
      isSaving: false,
      isChecking: false,
      isCodeSending: false,
      isConfirmationOpened: false,
      isEnabled: point.isEnabled || point.isActive || false,
      isEditDisabled: point.type === confirmedPointType,
    }));

    return {
      ...state,
      points: newPoints,
    };
  }

  return state;
};

export const changeTogglingStatusOfNotificationPoint = (state, type, isToggling = true) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isToggling,
    } : point)),
});

export const toggleNotificationPoint = (state, { type, value }) => {
  if (state && state.points) {
    const { points } = state;
    const pointIndex = points
      .findIndex((point) => point.type === type);
    const point = points[pointIndex];

    if (point) {
      return {
        ...state,
        points: [
          ...points.slice(0, pointIndex),
          {
            ...point,
            isEnabled: value,
            isToggling: false,
          },
          ...points.slice(pointIndex + 1),
        ],
      };
    }
  }

  return state;
};

export const togglePointEditingState = (state, { type, isEditing }) => ({
  ...state,
  points: state.points?.map((point) => (point.type === type ? {
    ...point,
    isEditing,
  } : point)),
});

export const updateNotificationPointValue = (state, { type, value }) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      value,
      isConfirmed: false,
      isCodeInvalid: false,
    } : point)),
});

export const setCodeValidity = (state, type, isCodeInvalid = false) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isCodeInvalid,
      isConfirmed: !isCodeInvalid,
    } : point)),
});

export const resetNotificationPointCodeValidation = (state, type) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isCodeInvalid: false,
    } : point)),
});

export const toggleSavingStatus = (state, type, isSaving = true) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isSaving,
    } : point)),
});

export const toggleCheckingStatus = (state, type, isChecking = true) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isChecking,
    } : point)),
});

export const toggleCodeSendingStatus = (state, type, isCodeSending = true) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isCodeSending,
    } : point)),
});

export const toggleConfirmationCodePopup = (state, { type, isConfirmationOpened }) => ({
  ...state,
  points: state.points
    .map((point) => (point.type === type ? {
      ...point,
      isConfirmationOpened,
    } : point)),
});
